import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-guest-login',
  templateUrl: './guest-login.component.html',
  styleUrls: ['./guest-login.component.scss']
})
export class GuestLoginComponent implements OnInit {

  code: string | null = null;
  name: string | null = null;

  showCodeInput = false;

  loginInProgress = false;

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService) {
    // redirect to home if already logged in
    if (this.authService.currentUserValue) {
      this.router.navigate(['/'], {replaceUrl: true});
    }

    this.route.params.subscribe(params => {
      if (params == null || params.code == null) {
        this.showCodeInput = true;
      } else {
        this.code = params.code;
      }
    });
  }

  ngOnInit(): void {
  }

  onLogin(valid: boolean | null): void {
    if (!this.loginInProgress && valid && this.code != null && this.name != null && this.name.trim().length > 0) {
      this.loginInProgress = true;

      this.authService.loginAsGuest({username: this.name, password: this.code, oauth: false})
        .pipe(first())
        .subscribe({
          next: () => {
            // get return url from route parameters or default to '/'
            const returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
            this.router.navigate([returnUrl], {replaceUrl: true});
          }, error: () => this.loginInProgress = false, complete: () => this.loginInProgress = false
        });
    }
  }

}
